import { useState } from "react";
import { api, formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Split, Save } from "lucide-react";
import { toast } from "sonner";
import { setActiveClass } from "@/lib/activeClass";

export default function SplitPanel({ cls, classes, students }) {
  const [map, setMap] = useState({});
  const [busy, setBusy] = useState(false);
  if (!cls) return null;
  const merged = (cls.niveaux || []).length > 1 && !cls.split_into;
  const toAssign = cls.split_into?.length > 0;
  if (!merged && !toAssign) return null;

  const split = async () => {
    if (!window.confirm(`Séparer « ${cls.nom} » en classes distinctes (${cls.niveaux.join(", ")}) ? Aucun élève ne sera déplacé automatiquement.`)) return;
    setBusy(true);
    try { await api.post(`/classes/${cls.id}/split`); toast.success("Classes créées. Affectez maintenant chaque élève."); setActiveClass(cls.id); window.location.reload(); }
    catch (e) { toast.error(formatError(e)); setBusy(false); }
  };

  const save = async () => {
    const assignments = Object.entries(map).filter(([, c]) => c).map(([student_id, class_id]) => ({ student_id, class_id }));
    if (!assignments.length) return toast.error("Choisissez la classe d'au moins un élève");
    setBusy(true);
    try {
      const { data } = await api.post(`/classes/${cls.id}/assign`, { assignments });
      toast.success(`${data.moved} élève(s) affecté(s) — ${data.restants} restant(s)`);
      window.location.reload();
    } catch (e) { toast.error(formatError(e)); setBusy(false); }
  };

  if (merged) {
    return (
      <div className="ek-card p-4 border-2 border-[#E6B800]/50 flex items-center gap-3 flex-wrap" data-testid="split-banner">
        <Split className="w-5 h-5 text-[#B38F00]" />
        <p className="text-sm flex-1 min-w-[220px]">La classe <b>{cls.nom}</b> regroupe plusieurs niveaux ({cls.niveaux.join(", ")}). Séparez-la pour gérer chaque classe indépendamment.</p>
        <Button onClick={split} disabled={busy} className="bg-[#1F7A63] hover:bg-[#165c4b] text-white" data-testid="split-btn">Séparer en classes distinctes</Button>
      </div>
    );
  }
  const targets = classes.filter((c) => cls.split_into.includes(c.id));
  return (
    <div className="ek-card p-0 border-2 border-[#E6B800]/50" data-testid="assign-panel">
      <div className="px-4 py-3 border-b border-[#E2E8F0] text-sm">
        <b>Affectation manuelle</b> — indiquez la classe de chaque élève ({students.length} restant(s)). Les absences et la vie scolaire suivent l&apos;élève ; les notes déjà saisies restent consultables dans cette classe.
      </div>
      <div className="divide-y divide-[#E2E8F0] max-h-96 overflow-y-auto">
        {students.map((s) => (
          <div key={s.id} className="flex items-center gap-3 px-4 py-2" data-testid="assign-row">
            <span className="flex-1 text-sm"><span className="font-normal">{s.prenom}</span> <span className="font-semibold">{s.nom}</span></span>
            <Select value={map[s.id] || ""} onValueChange={(v) => setMap({ ...map, [s.id]: v })}>
              <SelectTrigger className="w-40" data-testid="assign-select"><SelectValue placeholder="Classe…" /></SelectTrigger>
              <SelectContent>{targets.map((c) => <SelectItem key={c.id} value={c.id}>{c.nom}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        ))}
      </div>
      <div className="p-3 flex justify-end"><Button onClick={save} disabled={busy} className="bg-[#1F7A63] hover:bg-[#165c4b] text-white" data-testid="assign-save"><Save className="w-4 h-4 mr-1" /> Enregistrer les affectations</Button></div>
    </div>
  );
}
